import axios from 'axios';
import { ElMessage } from 'element-plus'
import { Local,Session } from './storage';
import { AES_Encrypt } from './secret'

// let URL = import.meta.env.VITE_APP_API_URL
// console.log(URL)

// let URL ;
//
// if ( window.location.toString().startsWith('https://web1k6xaop.bqskk.cn') ){
//   URL = 'https://api1xjl9xvb.bqskk.cn/'
// }else if ( window.location.toString().startsWith('https://web20xalg.xribml.cn') ) {
//   URL = 'https://api8xal1jfp.xribml.cn/'
// }else {
//   URL = 'http://27.124.2.71:8500/';
// }
const getBaseURL = () => {
  let lang = Local.get('lang');
  if (lang){
    return lang
  }else {
    return 'zh_CN'
  }

}

// 配置新建一个 axios 实例
const service = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL,
  // baseURL: 'https://api.kuex.io/',
  timeout: 50000,
  headers: {
    'Content-Type': 'multipart/form-data' ,
    'version': '1.0.0',
    'equipment':'userAgentobj',
    'mobile-model':'IOS',
    'system':'3'
  },
});

// 添加请求拦截器
service.interceptors.request.use(
  (config:any) => {
    // 在发送请求之前做些什么 token
    // config.headers.token = Local.get('token');
    // config.headers.equipment = Local.get('equipment') || 'userAgentobj'
    config.headers.lang = getBaseURL()
    console.log(config.headers.lang)
    var date:any = new Date();
    var timestamp:number = Math.round(date / 1000);
    config.data['timestamp']=timestamp ;
    let jsonstr = JSON.stringify(config.data);
    let EncryptData = AES_Encrypt(jsonstr)
        config.data = {body:EncryptData}
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    const res = response.data;

    if (res.code && res.code != 0) {
      // `token` 过期或者账号已在别处登录
      if (res.code === 403 || res.code === 4001 ) {
        Local.clear(); // 清除浏览器全部临时缓存
        Session.clear();
        // window.location.href = '#/Login'; // 去登录页
        // ElMessage.error('Login expired, please log in again')
      }else if(res.code === 405){
        // ElMessage.error('Google Authentication required')
      }else if(res.code === 401){
        // ElMessage.error('You need to go to the APP for real-name verification')
      }else{
        ElMessage.error(res.msg)
      }
      return Promise.reject(service.interceptors.response);
    } else {
      return response.data;
    }
  },
  (error) => {
    // 对响应错误做点什么
    if (error.message.indexOf('timeout') != -1) {
      // ElMessage.error('Network timeout');
    } else if (error.message == 'Network Error') {
      // ElMessage.error('Network connection error');
    } else if (error.message == 'Request failed with status code 500') {
      // ElMessage.error(error.message);
    } else if (error.message == 'Request failed with status code 401') {
      Local.clear();
      Session.clear();// 清除浏览器全部临时缓存
      // window.location.href = '#/login'; // 去登录页
      // ElMessage.error('You have been logged out, please log in again')
    } else {
      if (error.response){
        // ElMessage.error(error.response.statusText)
      }

      else {
        // ElMessage.error('Interface path not found');
      }

    }
    return Promise.reject(error.message);
  }
);


// 导出 axios 实例
export default service;
